import { render, staticRenderFns } from "./rulesRead.vue?vue&type=template&id=4e183e3d&scoped=true&"
import script from "./rulesRead.vue?vue&type=script&lang=js&"
export * from "./rulesRead.vue?vue&type=script&lang=js&"
import style0 from "./rulesRead.vue?vue&type=style&index=0&id=4e183e3d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e183e3d",
  null
  
)

export default component.exports